import { render, staticRenderFns } from "./attrForm.vue?vue&type=template&id=13daad59&scoped=true&"
import script from "./attrForm.vue?vue&type=script&lang=js&"
export * from "./attrForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13daad59",
  null
  
)

export default component.exports